export default function useRights() {

    const ACCESS_TYPE = {
        CREATE: 'create',
        READ: 'read',
        EDIT: 'edit',
        DELETE: 'delete',
    }

    const RIGHTS = {
        Admin: false,
        discount: {
            create: false,
            read: false,
            edit: false,
            delete: false
        },
        purchase: {
            create: false,
            read: false,
            edit: false,
            delete: false
        },
        receiving: {
            create: false,
            read: false,
            edit: false,
            delete: false
        },
        userManagement: {
            create: false,
            read: false,
            edit: false,
            delete: false
        },
        orders: {
            create: false,
            read: false,
            edit: false,
            delete: false
        },
        productFilter: {
            create: false,
            read: false,
            edit: false,
            delete: false
        },
        syncErrors: {
            create: false,
            read: false,
            edit: false,
            delete: false
        },
        correctItems: {
            create: false,
            read: false,
            edit: false,
            delete: false
        },
        po: {
            create: false,
            read: false,
            edit: false,
            delete: false
        },
        vendors: {
            create: false,
            read: false,
            edit: false,
            delete: false
        },
        items: {
            create: false,
            read: false,
            edit: false,
            delete: false
        },

    }

    return {RIGHTS, ACCESS_TYPE}
}